/* src/app/builder-screen-beta/components/column-manager/column-manager.component.scss */
.columns-list {
  max-height: 60vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.columns-list::-webkit-scrollbar {
  width: 6px;
}
.columns-list::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 3px;
}
.columns-list::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 3px;
}
.columns-list::-webkit-scrollbar-thumb:hover {
  background: #bfbfbf;
}
.column-card {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background: #fff;
  transition: all 0.2s ease;
}
.column-card:hover {
  border-color: #d9d9d9;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
.column-card.expanded {
  border-color: #1890ff;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15);
}
.column-card.new-column {
  border-color: #91d5ff;
  border-style: dashed;
  background: #e6f7ff;
}
.column-summary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  cursor: pointer;
  min-height: 40px;
  -webkit-user-select: none;
  user-select: none;
}
.column-summary:hover {
  background: #fafafa;
  border-radius: 8px;
}
.column-summary.new-header {
  cursor: default;
  padding: 10px 12px;
  gap: 6px;
  color: #1890ff;
}
.column-summary.new-header:hover {
  background: transparent;
}
.drag-handle {
  cursor: grab;
  color: #bfbfbf;
  font-size: 14px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}
.drag-handle:active {
  cursor: grabbing;
}
.drag-handle:hover {
  color: #8c8c8c;
}
.column-index {
  font-size: 11px;
  color: #bfbfbf;
  font-weight: 600;
  min-width: 16px;
  text-align: center;
  flex-shrink: 0;
}
.type-tag {
  flex-shrink: 0;
  font-size: 11px !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center;
  gap: 3px;
}
.column-name {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
}
.column-name strong {
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.column-name code {
  font-size: 10px;
  color: #8c8c8c;
  background: #f5f5f5;
  padding: 1px 5px;
  border-radius: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
}
.column-badges {
  display: flex;
  gap: 3px;
  flex-shrink: 0;
}
.column-badges .badge {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  background: #f5f5f5;
  color: #d9d9d9;
  transition: all 0.15s;
}
.column-badges .badge.active {
  background: #e6f7ff;
  color: #1890ff;
}
.column-actions {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}
.column-detail {
  padding: 12px 16px 16px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
  border-radius: 0 0 8px 8px;
  animation: expandIn 0.2s ease-out;
}
.column-detail .detail-row {
  display: grid;
  gap: 10px;
  margin-bottom: 10px;
}
.column-detail .detail-row.two-cols {
  grid-template-columns: 1fr 1fr;
}
.column-detail .detail-row.three-cols {
  grid-template-columns: 1fr 1fr 100px;
}
.column-detail .detail-row.toggles {
  grid-template-columns: auto auto auto;
  justify-content: start;
  gap: 16px;
  margin-bottom: 12px;
}
.column-detail ::ng-deep nz-form-item {
  margin-bottom: 0;
}
.column-detail ::ng-deep nz-form-label {
  padding: 0 0 2px !important;
}
.column-detail ::ng-deep nz-form-label label {
  font-size: 11px;
  color: #8c8c8c;
  height: auto;
}
.column-detail ::ng-deep .ant-checkbox-wrapper {
  font-size: 12px;
}
.detail-extra {
  margin-top: 4px;
  padding-top: 0;
}
.detail-extra ::ng-deep nz-divider {
  margin: 8px 0 !important;
  font-size: 11px !important;
}
.dropdown-option-row {
  display: flex;
  gap: 8px;
  margin-bottom: 6px;
  align-items: center;
}
.detail-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px dashed #e8e8e8;
}
.empty-state {
  padding: 32px 0;
  text-align: center;
}
.drag-placeholder {
  border: 2px dashed #91d5ff;
  border-radius: 8px;
  background: #e6f7ff;
  min-height: 40px;
  transition: transform 0.2s;
}
.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.cdk-drag-preview {
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  background: #fff;
  border: 1px solid #1890ff;
}
.cdk-drag-preview .column-detail {
  display: none;
}
.columns-list.cdk-drop-list-dragging .column-card:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
@keyframes expandIn {
  from {
    opacity: 0;
    max-height: 0;
  }
  to {
    opacity: 1;
    max-height: 600px;
  }
}
@media (max-width: 600px) {
  .column-summary {
    flex-wrap: wrap;
    gap: 4px;
  }
  .column-name {
    order: 5;
    flex-basis: 100%;
  }
  .column-detail .detail-row.two-cols,
  .column-detail .detail-row.three-cols {
    grid-template-columns: 1fr;
  }
}
/*# sourceMappingURL=column-manager.component.css.map */
